import CommentIcon from "@mui/icons-material/Comment";
import CommentsDisabledIcon from "@mui/icons-material/CommentsDisabled";
import { type SvgIconProps } from "~/common/mui";
import { forwardRef } from "react";

export interface Props extends SvgIconProps {
  open?: boolean;
}

export const ToggleCommentIcon = forwardRef<SVGSVGElement, Props>(({ open, ...props }, ref) =>
  open ? (
    <CommentsDisabledIcon ref={ref} {...props} color={"primary"} />
  ) : (
    <CommentIcon ref={ref} {...props} color={"primary"} />
  ),
);
